import { styled, keyframes } from "@/styles/theme"
import useOnClickOutside from "react-cool-onclickoutside"

const scaleIn = keyframes({
  "0%": { opacity: 0, transform: "scale(0)" },
  "100%": { opacity: 1, transform: "scale(1)" },
})

const DropdownRoot = styled("div", {
  position: "relative",
})

const DropdownTrigger = styled("div", {
  cursor: "pointer",
  userSelect: "none",
  background: "none",
  border: 0,
  padding: "$4 $5",
  "&:focus": {
    outline: "$colors$gray-light",
  },
})

const DropdownContent = styled("div", {
  transformOrigin: "var(--radix-dropdown-menu-content-transform-origin)",
  animation: `${scaleIn} 150ms ease-out`,
  boxShadow: "$8dp",
  borderRadius: "$1",
  backgroundColor: "$white",
  width: "185px",
  padding: "$1 0",
  position: "absolute",
  zIndex: "$900",
  right: "10px",
  top: "0px",
  display: "none",
  variants: {
    isOpen: {
      true: {
        display: "block",
      },
    },
  },
})

const DropdownItem = styled("div", {
  margin: "$2",
  padding: "$3 $4",
  cursor: "pointer",
  "> img": {
    marginRight: "$4",
  },
  "&:hover, &:focus, &:active": {
    borderRadius: "$1",
    outline: 0,
    border: 0,
    backgroundColor: "$gray-light",
  },
})

const DropdownSeparator = styled("div", {
  height: 1,
  my: "$1",
  backgroundColor: "$gray-light",
})

function Dropdown(props) {
  const {
    isOpen,
    setIsOpen,
    children,
    className=null,
    triggerComponent,
    disabled = false,
  } = props

  const ref = useOnClickOutside(() => {
    setIsOpen(false)
  })

  return (
    <Dropdown.Root className={className}>
      <Dropdown.Trigger
        // className={className}
        onClick={() => {
          if (!disabled) setIsOpen(!isOpen)
        }}
      >
        {triggerComponent}
      </Dropdown.Trigger>
      <Dropdown.Content isOpen={isOpen} ref={ref}>
        {children}
      </Dropdown.Content>
    </Dropdown.Root>
  )
}

Dropdown.Root = DropdownRoot
Dropdown.Content = DropdownContent
Dropdown.Trigger = DropdownTrigger
Dropdown.Item = DropdownItem
Dropdown.Separator = DropdownSeparator

export { Dropdown }
